<template>
  <!-- 热血盲盒管理-房间数据-房间详情弹窗 -->
  <div>
    <el-dialog
      :visible.sync="showMark"
      :close-on-click-modal="false"
      title="房间详情"
      width="1000px"
      @close="closeDialog"
      center
    >
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item v-for="item in dataList && dataList.user" :key="item.id">
          <el-card class="box-card" style="width: 220px">
            <div slot="header" class="clearfix">
              <span>座位{{ item.seatNumber }}</span>
            </div>
            <div class="text item">
              用户头像：
              <img
                style="border: 1px solid #eee; width: 50px"
                :src="item.avatar"
                alt=""
                v-if="item.avatar"
              />
              <span v-else>无</span>
            </div>
            <div class="text item">用户姓名：{{ item.name }}</div>
            <div class="text item">用户id：{{ item.id }}</div>
            <div class="text item">用户编码：{{ item.seed_code }}</div>
          </el-card>
        </el-form-item>
      </el-form>
      <div class="type-box">
        <div
          :class="{ 'type-btn': 1, active: typeFlag == 1 }"
          @click="typeFlag = 1"
        >
          原本出奖
        </div>
        <div
          :class="{ 'type-btn': 1, active: typeFlag == 2 }"
          @click="typeFlag = 2"
        >
          最终结果
        </div>
      </div>
      <!-- 最终结果 -->
      <div class="finally-box" v-if="typeFlag == 2">
        <div
          class="user-box"
          v-for="(item, index) in dataList && dataList.finallyArr"
          :key="index"
        >
          <div class="title-box">座位{{ index + 1 }}</div>
          <div
            class="prize-box"
            v-for="(itemPrize, index) in dataList && item"
            :key="index"
          >
            <img width="50" :src="itemPrize.image" alt="" />
            <p>{{ itemPrize.name }}</p>
          </div>
        </div>
      </div>
      <!-- 原本出奖 -->
      <el-table
        v-if="typeFlag == 1"
        class="from-overview"
        v-loading="loading"
        :data="dataList && dataList.mergeArr"
      >
        <el-table-column prop="round" label="回合" align="center">
        </el-table-column>
        <el-table-column label="座位1" align="center">
          <template slot-scope="{ row }">
            <div v-if="row.user1">
              <img width="50" :src="row.user1.image" alt="" />
              <p>{{ row.user1.name }}</p>
              <p>{{ row.user1.price }}</p>
            </div>
            <span v-else>无</span>
          </template>
        </el-table-column>
        <el-table-column label="座位2" align="center">
          <template slot-scope="{ row }">
            <div v-if="row.user2">
              <img width="50" :src="row.user2.image" alt="" />
              <p>{{ row.user2.name }}</p>
              <p>{{ row.user2.price }}</p>
            </div>
            <span v-else>无</span>
          </template>
        </el-table-column>
        <el-table-column label="座位3" align="center">
          <template slot-scope="{ row }">
            <div v-if="row.user3">
              <img width="50" :src="row.user3.image" alt="" />
              <p>{{ row.user3.name }}</p>
              <p>{{ row.user3.price }}</p>
            </div>
            <span v-else>无</span>
          </template>
        </el-table-column>
        <el-table-column label="座位4" align="center">
          <template slot-scope="{ row }">
            <div v-if="row.user4">
              <img width="50" :src="row.user4.image" alt="" />
              <p>{{ row.user4.name }}</p>
              <p>{{ row.user4.price }}</p>
            </div>
            <span v-else>无</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :page-size="dataMeta.per_page || 15"
        :total="dataMeta.total || 0"
        :current-page="dataMeta.current_page"
        @current-change="handlePageChange"
        v-if="dataMeta && dataMeta.total > dataMeta.per_page"
      ></el-pagination>
    </el-dialog>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import { server, postData, delData, patchData, getData, postApiData } from '../../http'

export default {
  components: {
  },
  props: {
    value: {
      type: Object,
      default: undefined
    },
    visible: {//展示标志
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,//加载动画
      buttonLoading: false,//加载按钮动画
      typeFlag: 1,//表单类型 1是最终结果 2是原本出奖
      query: {//查询
        page: 1
      },
      dataList: undefined,//数据列表
      dataMeta: undefined,//不底部分页
    }
  },
  computed: {
    ...mapState({
    }),
    showMark: {
      get() {
        return this.visible
      },
      set(bool) {
      }
    },
    dialogInfos: {
      get() {
        return this.value
      },
      set(bool) {
      }
    }
  },
  watch: {
    showMark(val) {
      if (val) {
        this.getData()//获取数据列表
      }
    }
  },
  created() {
  },
  mounted() { },
  methods: {
    ...mapMutations(['']),
    ...mapActions(['']),
    getData() {
      //获取数据列表
      this.loading = true
      getData(`battle_room_details/${this.dialogInfos.rid}`)
        .then(res => {
          this.dataList = res
          this.combinationData(res)
          this.dataMeta = res
        })
        .finally(() => {
          this.loading = false
        })
    },
    combinationData(data) {
      //原本数据
      let mergeArr = []
      for (let j = 0; j < data.room.type; j++) {
        let cacheArr = []
        for (let i = 0, len = data.prize.length; i < len; i++) {
          if (data.prize[i].round === j + 1) {
            //相同回合的数据放一起
            cacheArr.push(data.prize[i])
          }
        }

        if (cacheArr && cacheArr.length) {
          let obj = {
            round: j + 1,
            user1: cacheArr[0],
            user2: cacheArr[1],
            user3: cacheArr[2],
            user4: cacheArr[3]
          }
          mergeArr.push(obj)
        }
      }

      //最终结果
      let finallyArr = []
      for (let k = 0; k < data.user.length; k++) {
        let userPrize = []
        for (let f = 0, len = data.settle.length; f < len; f++) {
          if (data.user[k].id === data.settle[f].uid) {
            //相同回合的数据放一起
            userPrize.push(data.settle[f])
          }
        }
        finallyArr.push(userPrize)
      }

      this.dataList.mergeArr = mergeArr
      this.dataList.finallyArr = finallyArr
      this.dataList.userList = data.user
    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData();
    },
    closeDialog() {
      //关闭弹窗
      this.$emit("close")
    },

  }

}
</script>
<style lang="less" scoped>
.type-box {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .type-btn {
    color: #000;
    user-select: none;
    cursor: pointer;
    padding: 10px 20px;
    margin: 10px;
    border: 1px solid rgb(64, 158, 255);
    border-radius: 5px;
    &.active {
      color: #fff;
      background: rgb(64, 158, 255);
    }
  }
}

.finally-box {
  display: flex;
  .user-box {
    width: 25%;
    .title-box {
      display: flex;
      justify-content: center;
      padding: 10px;
      border-top: 1px solid rgb(161, 160, 160);
      border-bottom: 1px solid rgb(161, 160, 160);
      &:last-child {
        border-right: 0px;
      }
    }
    .prize-box {
      min-height: 100px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 10px;
      border-bottom: 1px solid rgb(161, 160, 160);
    }
  }
}
</style>